import React from 'react';
import _ from 'lodash';

import completedIcon from 'assets/icons/circle-check2.svg';
import inProgressIcon from 'assets/icons/circle-in-progress.svg';
import waitingIcon from 'assets/icons/clock.svg';

import './styles.css';

const STAGE_STATUS_TO_ICON_MAPPER = {
  ['Waiting']: waitingIcon,
  ['In Progress']: inProgressIcon,
  ['Completed']: completedIcon
};

const DEPOSIT_PAID_STAGE_KEY_FOR_API = 'depositPaidStage';
const ARRIVAL_STAGE_KEY_FOR_API = 'arrivalStage';
const DEPARTURE_STAGE_KEY_FOR_API = 'departureStage';
const DEPOSIT_CHARGE_OR_REFUND_STAGE_KEY_FOR_API = 'depositRefundOrChargeStage';

const TIMELINE_HEADINGS_MAPPER = {
  [DEPOSIT_PAID_STAGE_KEY_FOR_API]: 'Deposit Paid',
  [ARRIVAL_STAGE_KEY_FOR_API]: 'Arrival Room Check Completed',
  [DEPARTURE_STAGE_KEY_FOR_API]: 'Departure Room Check Completed',
  [DEPOSIT_CHARGE_OR_REFUND_STAGE_KEY_FOR_API]: 'Deposit Charge/ Refund'
};

/*
We convert room checks timeline from BE in the following format:
{
  deposit_paid_stage: 'In Progress',
  arrival_stage: 'In Progress',
  departure_stage: 'In Progress',
  deposit_refund_or_charge_stage: 'Waiting',
}

to timeline in the following format:
[
  {
    heading: 'Deposit Paid',
    status: 'In Progress'
  },
  {
    heading: 'Check in Inspection Completed',
    status: 'In Progress'
  },
  {
    heading: 'Check out Inspection Completed',
    status: 'In Progress'
  },
  {
    heading: 'Deposit Charge/ Refund',
    status: 'Waiting'
  },
]
*/

const RoomChecksTimeline = ({roomChecksTimeline = {}}) => {
  const stages: any = _.map(roomChecksTimeline, (value, key) => ({
    heading: TIMELINE_HEADINGS_MAPPER[key],
    status: value
  }));

  return (
    <div className="RoomChecksTimeline colab-centered-v">
      {stages.map(stage => (
        <React.Fragment key={stage.heading}>
          <div className="RoomChecksTimeline__stageContainer">
            <div className="RoomChecksTimeline__stage colab-centered">
              <div>
                <img
                  className="colab-sidepadding-1"
                  src={STAGE_STATUS_TO_ICON_MAPPER[stage.status]}
                />
              </div>
              <div className="RoomChecksTimeline__stage--heading colab-bold">
                {stage.heading}
              </div>
            </div>
          </div>
          <div className="RoomChecksTimeline__stage--horizontalLine" />
        </React.Fragment>
      ))}
    </div>
  );
};

export default RoomChecksTimeline;
